export function isFile(object) {
  return object && (object.constructor.name === 'File' || object.constructor.name === 'FileList');
}

export function isBlob(object) {
  return object && object.constructor.name === 'Blob';
}

export const arrayMove = (arr, old_index, new_index) => {
  if (new_index >= arr.length) {
    let k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
};

export const updateIdx = (arr) => {
  return arr.map((x, _index) => {
    x.idx = _index
    return x
  })
}

export const deleteItemByProp = (arr, obj, id_prop = 'id') => {
  if (obj[id_prop]) {
    arr.find(x => x.uuid === obj.uuid).is_deleted = true
  } else {
    arr.splice(arr.findIndex(x => x.uuid === obj.uuid), 1)
  }
}

export const getImageCounters = (counters, id) => {
  return counters[id].with_polygons + counters[id].no_polygons
}


export const handleObjectsListToSearchSuggest = (items) => {
  return items.map(x => {
    return {
      label: x.label,
      key: x.id,
      fuzzy: x.fuzzy,
      raw: x
    }
  })
}
